/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemAggregationResultSchema } from './itemAggregationResultSchema';

export const itemAggregationsResultsSchema = z.object({
  get aggregations() {
    return z.array(itemAggregationResultSchema);
  },
  id: z.int(),
});
